import { Delete, Edit } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useRole_deleteMutation,
  useRole_listMutation,
  useRole_statusMutation,
} from "../constants/redux/api/api";
import { Row, Col, Pagination, Button, Form } from "react-bootstrap";
import BTable from "react-bootstrap/Table";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import { GlobalFilter } from "../constants/Storage/GlobalFilter";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { loadergif } from "../assets/img";
function Table({ columns, data }) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,

    globalFilter,
    setGlobalFilter,

    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <>
      {/* <Row className="mb-3">
        <Col className="d-flex align-items-center">
          <p>Show</p>

          <select
            className="form-control w-auto mx-2 p-2 py-1"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[5, 10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
          <p>entries</p>
        </Col>
        <Col className="d-flex justify-content-end">
          <GlobalFilter filter={globalFilter} setFilter={setGlobalFilter} />
          <Link to="/support/add-support">
            <Button style={{ background: 'rgb(95,188,95)' }} className="btn-sm btn-round has-ripple ml-2 border-0">
              <i className="feather icon-plus" /> Add Ticket
            </Button>
          </Link>
        </Col>
      </Row> */}
      <BTable size="sm" responsive {...getTableProps()} variant="dark">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                // Add the sorting props to control sorting. For this example
                // we can add them into the header props
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render("Header")}
                  {/* Add a sort direction indicator */}
                  <span>
                    {column.isSorted ? (
                      column.isSortedDesc ? (
                        <span className="feather icon-arrow-down text-muted float-right" />
                      ) : (
                        <span className="feather icon-arrow-up text-muted float-right" />
                      )
                    ) : (
                      ""
                    )}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </BTable>
      <Row className="justify-content-between table-show my-2">
        {/* <Col>
          <span className="d-flex align-items-center">
            <p className="px-1">Page</p>{" "}
            <strong>
              {" "}
              {pageIndex + 1} of {pageOptions.length}{" "}
            </strong>{" "}
            <p className="px-1">|</p>
            <p className="px-1">Go to page:</p>{" "}
            <input
              type="number"
              className="form-control ml-2  p-1 py-1 text-center"
              defaultValue={pageIndex + 1}
              onChange={(e) => {
                const page = e.target.value ? Number(e.target.value) - 1 : 0;
                gotoPage(page);
              }}
              style={{ width: "40px" }}
            />
          </span>
        </Col> */}
        <Col>
          <Pagination className="justify-content-end" size="lg">
            <Pagination.First
              onClick={() => gotoPage(0)}
              disabled={!canPreviousPage}
            />
            <Pagination.Prev
              onClick={() => previousPage()}
              disabled={!canPreviousPage}
            />
            <Pagination.Next
              onClick={() => nextPage()}
              disabled={!canNextPage}
            />
            <Pagination.Last
              onClick={() => gotoPage(pageCount - 1)}
              disabled={!canNextPage}
            />
          </Pagination>
        </Col>
      </Row>
    </>
  );
}

const RolesList = () => {
  const [loading, setLoading] = useState(false);
  const [roleList, setRoleList] = useState([]);
  const navigate = useNavigate();

  //   Rtk Query
  const [role_list] = useRole_listMutation();
  const [role_status] = useRole_statusMutation();
  const [role_delete] = useRole_deleteMutation();

  const GetRoleList = async () => {
    setLoading(true)
    role_list()
      .unwrap()
      .then((res) => {
        if (res?.status === "success") {
          let temp = [];
          res?.data?.map((item, ind) => {
            temp.push(item);
          });
          setRoleList(temp.reverse());
          setLoading(false)
        }
      })
      .catch((err) => {
        setLoading(false)
        console.log(err, "err");
      });
  };

  const handleStatusChange = (_id) => {
    if (_id) {
      role_status(_id)
        .unwrap()
        .then((res) => {
          if (res?.status === "success") {
            GetRoleList();
          }
        })
        .catch((err) => {
          console.log(err, "err");
        });
    }
  };

  useEffect(() => {
    GetRoleList();
  }, []);

  const handleClickDelete = (_id, mail) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        role_delete(_id)
          .unwrap()
          .then((res) => {
            if (res?.status === "success") {
              toast.success(res?.message);
              GetRoleList();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "sno",
        Cell: ({ value, row }) => {
          return <p>{row.index + 1}</p>;
        },
      },
      {
        Header: "Roles Name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <button
              onClick={() => {
                handleStatusChange(row.original._id);
              }}
              className={`${
                value ? "bg-success" : "bg-danger"
              } px-2 py-1 rounded-1 border-0 text-white`}
            >
              {value ? "Active" : "Deactive"}
            </button>
          );
        },
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex justify-content-center gap-2">
              <button
                onClick={() =>
                  navigate("/add-roles", {
                    state: { type: "edit", data: row.original },
                  })
                }
                className="bg-primary text-white border-0 rounded-1 p-1 me-2"
              >
                <Edit />
              </button>
              {/* <button
                className="bg-warning border-0 rounded-1 p-1"
                onClick={() =>
                  handleClickDelete(row.original._id, row.original.email)
                }
              >
                <Delete />
              </button> */}
              <button
                onClick={() =>
                  navigate("/add-roles", {
                    state: { type: "view", data: row.original },
                  })
                }
                type="button"
                className="btn btn-secondary text-white border-0 rounded-1 p-1 me-2"
              >
                <VisibilityIcon />
                </button>
            </div>
          );
        },
      },
    ],
    []
  );

  return (
    <>
      {/* <div className="table-responsive menu-table side_pad mt-4">
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Roles Name</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody className="">
            {roleList?.map((data, i) => {
              const { name, status, _id } = data;
              return (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{name}</td>
                  <td>
                    <button
                      onClick={() => {
                        handleStatusChange(_id);
                      }}
                      className={`${
                        status ? "bg-success" : "bg-danger"
                      } px-2 py-1 rounded-1 border-0 text-white`}
                    >
                      {status ? "Active" : "Deactive"}
                    </button>
                  </td>
                  <td>
                    <button
                      onClick={() =>
                        navigate("/add-roles", {
                          state: { type: "edit", data: data },
                        })
                      }
                      className="bg-primary text-white border-0 rounded-1 p-1 me-2"
                    >
                      <Edit />
                    </button>
                    <button className="bg-warning border-0 rounded-1 p-1">
                      <Delete />
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div> */}
      {loading && (
      <div
        style={{ zIndex: 1500, position: "fixed", top: "45%", left: "49%" }}>  
        <span style={{ marginLeft: 10 }}><img src={loadergif}/></span>
      </div>
    )}
      <div className="table-responsive menu-table side_pad mt-4">
        <Table columns={columns} data={roleList} className="" />
      </div>
    </>
  );
};

export default RolesList;
